import './pisces/style';
import FormStructure from './pisces/form_structure';

export default FormStructure;